import React from 'react';
import { Pagination, } from 'react-bootstrap';
import { Modal, Carousel } from 'react-bootstrap';
import { format } from 'date-fns';
import { history } from '../../store';
import '../../../public/css/media/_shipment.scss';
import ReactDOM from 'react-dom';
import { numbersWithComma, maskEventRemarks, isMigratedEventRemarks, maskLocationName, netcoreScript, disabledCart, maskOriginID } from '../../utils/utils';
import { v4 as uuid } from 'uuid';
// import AlertAdvisory from '../AlertAdvisory';
import AdvisoryModal from '../AdvisoryModal';
import Tour from './Tour';
import axios from 'axios';
import CommonConstants from '../../utils/CommonConstants';
import OutBoundBanner from '../OutBoundBanner';
import DamagedBanner from '../DamagedBanner';
import DamagedModal from '../DamagedModal';
import { handleAppUrl } from '../../utils/urls';
const apiUrl = CommonConstants.Actions.api;

const createReactClass = require('create-react-class');
const Shipment = createReactClass({
  getInitialState() {
    return {
      activePage: 1,
      per_page: 10,
      status: "",
      range: "",
      value: "3months",
      showModalImage: false,
      collapsedTrackDetails: [],
      showModal: false,
      body: "<div></div>",
      image: null,
      zoomIndex: 0,
      zoomDirection: null,
      tabID: "All",
      settings: false,
      isDownloading: false,
      damagedModalOpen: false,
      damagedItemsList: null,
    };
  },
  close1() {
    this.setState({ showModal: false, showModalSplit: false, });
  },
  open(tracking_number, e) {
    e.preventDefault();
    this.setState({ showModal: true, });
    this.props.getOrderDetails(tracking_number);
  },
  componentDidMount() {
    window.location.href = `${handleAppUrl()}/shipments`;
    window.scrollTo(0, 0);

    // <!-- NetCore Script -->
    const accountNumber = this.props.login.fetched && this.props.login.login && this.props.login.login.party && this.props.login.login.party.account_number ? this.props.login.login.party.account_number : '' ;
    window.smartech && netcoreScript(accountNumber);
    // <!-- NetCore Script -->        

    disabledCart && this.props.getModalBlocks('cart')
  },
  componentDidUpdate(prevProps) {
    if (this.props.login.error) {
      if (this.props.login.error.response.data.status === 401) {
        history.push("/signin");
      }
    }
    
    let hash = this.props.location.hash.replace('#', '');
    if (hash) {
      let node = ReactDOM.findDOMNode(this.refs[hash]);
      if (node) {
        node.scrollIntoView({
          block: 'center',
          behavior: 'smooth',
          inline: 'center' 
        });
      }
    }

    // if (prevProps.login.login.status !== this.props.login.login.status) {
    //   const email = this.props.login.login.party.email;
    //   this.setState({email},() => this.netcoreScript(this.state.email));
    // }
  },
  componentWillMount() {
    var page = this.state.activePage;
    var per_page = this.state.per_page;
    var status = this.state.status;

    this.props.getShipment(localStorage.jwtToken, page, per_page, status, this.state.value);
    const token = localStorage.jwtToken;
    this.props.signedIn(token);

  },
  componentWillReceiveProps(nextProps, nextState) {
    this.setState({ body: nextProps.shipmentInfo.fetched_order ? nextProps.shipmentInfo.order.data.charge.remarks : null, });
    document.title = "Shipments | ShippingCart";

    if (!nextState.settings && nextProps.shipmentInfo.shipment !== this.props.shipmentInfo.shipment) {
      if (nextProps.shipmentInfo.shipment && nextProps.shipmentInfo.shipment.data){
        const shipmentCountryCode = nextProps.shipmentInfo.shipment.data[0].pickup_address.country.code === 'US' ? 'OR' : nextProps.shipmentInfo.shipment.data[0].pickup_address.country.code;
        const shipmentWarehouseId = maskOriginID(shipmentCountryCode);
        this.props.getGlobalSettings(shipmentWarehouseId);
      }
    }
    if (nextProps.settings.globalSettings !== this.props.settings.globalSettings) {
      const { data } = nextProps.settings.globalSettings;
      const settings = data.map(item => item);
      this.setState({ settings });
    }
  },
  closeCollapse() {
    window.$('.collapse').collapse('hide');
  },
  handleSelect(eventKey) {
    this.setState({
      activePage: eventKey,
    });

    var per_page = this.state.per_page;
    var status = this.state.status;

    this.closeCollapse();
    this.props.getShipment(localStorage.jwtToken, eventKey, per_page, status, this.state.value);
    window.scrollTo(0, 0);
  },
  handleStatusDisplay(status) {
    this.closeCollapse();
    switch (status) {
      case "all":
        this.setState({ status: "",
          activePage: 1,
          tabID: "All"}, () =>
        this.props.getShipment(localStorage.jwtToken, this.state.activePage, this.state.per_page, this.state.status, this.state.value));
        break;
      case "pending":
        this.setState({ status: "pending",
          activePage: 1,
          tabID: "PendingPayment"}, () =>
        this.props.getShipment(localStorage.jwtToken, this.state.activePage, this.state.per_page, this.state.status, this.state.value));
        break;
      case "preparing":
        this.setState({ status: "confirmed,consolidated,for_pickup,for_consolidation",
          activePage: 1,
          tabID: "PreparingShipment"}, () =>
        this.props.getShipment(localStorage.jwtToken, this.state.activePage, this.state.per_page, this.state.status, this.state.value));
        break;
      case "inTransit":
        this.setState({ status: "failed_pickup,in_transit,out_for_delivery,failed_delivery,return_in_transit,returned,failed_return,for_acceptance,accepted,for_transfer,out_for_return,for_dropoff,dropped_off,received_at_delivery_hub,received_at_delivery_area,at_sorting_center,dws_update",
          activePage: 1,
          tabID: "InTransit"}, () =>
        this.props.getShipment(localStorage.jwtToken, this.state.activePage, this.state.per_page, this.state.status, this.state.value));
        break;
      case "delivered":
        this.setState({ status: "claimed,delivered,picked_up",
          activePage: 1,
          tabID: "Delivered"}, () =>
        this.props.getShipment(localStorage.jwtToken, this.state.activePage, this.state.per_page, this.state.status, this.state.value));
        break;
      default:
    }
  },
  change(event) { //change SPAN OF TIME (60 days, 2016,2017, etc)
    this.setState({ value: event.target.value, activePage: 1, }, function () {
      this.props.getShipment(localStorage.jwtToken, this.state.activePage, this.state.per_page, this.state.status, this.state.value);
    });
  },
  formatDateWithTime(arr) {
    if (arr) {
      arr = arr.split(" ");
      arr = arr[0];
      arr = arr.split("-");
      var res = [arr[1], arr[2], arr[0],];

      return res.join("/");
    }
    return arr;
  },
  handleStatuses(shipment_status, type, payment_status) {
    var str = shipment_status === "canceled" && payment_status === "rejected" ? payment_status :  shipment_status;

    if (str) {
      if (type === "class") {
        switch (str) {
          case "confirmed":
          case "for_pickup":
          case "consolidated":
          case "for_consolidation":
            return "paid";
          case "failed_pickup":
          case "in_transit":
          case "out_for_delivery":
          case "failed_delivery":
          case "return_in_transit":
          case "returned":
          case "failed_return":
          case "for_acceptance":
          case "accepted":
          case "received_at_pickup_hub":
          case "received_at_delivery_hub":
          case "for_return":
          case "received_at_delivery_area":
          case "at_sorting_center":
          case "in_transit_to_delivery_area":
          case "transferred_to_partner":
          case "for_transfer":
          case "out_for_return":
          case "for_dropoff":
          case "dropped_off":
          case "dws_update":
            return "transit";
          case "canceled":
          case "rejected":
            return "cancelled"
          case "delivered":
          case "claimed":
          case "picked_up":
            return "delivered";
          default:
            return str.replace("_", "-");
        }
      } else if (type === "text") {
        switch (str) {
          case "confirmed":
          case "for_pickup":
          case "consolidated":
          case "for_consolidation":
            return "PREPARING FOR SHIPMENT";
          case "failed_pickup":
          case "in_transit":
          case "out_for_delivery":
          case "failed_delivery":
          case "return_in_transit":
          case "returned":
          case "failed_return":
          case "for_acceptance":
          case "accepted":
          case "received_at_pickup_hub":
          case "received_at_delivery_hub":
          case "for_return":
          case "received_at_delivery_area":
          case "at_sorting_center":
          case "in_transit_to_delivery_area":
          case "transferred_to_partner":
          case "for_transfer":
          case "out_for_return":
          case "for_dropoff":
          case "dropped_off":
          case "dws_update":
            return "ON ITS WAY";
          case "canceled":
            return "CANCELLED"
          case "delivered":
          case "claimed":
          case "picked_up":
            return "DELIVERED";
          default:
            return str.replace("_", " ").toUpperCase();
        }
      }
    }
    return str;
  },
  handleImage(image) {
    let image1 = [];
    image.filter(item => item.type === "product").map(item => item.metadata.parcel.images.map(it => image1.push(it)));
    this.setState({ image: image1, showModalImage: true, });
    this.setState({ zoomIndex: 0, zoomDirection: null, });


  },
  close() {
    this.setState({ showModalImage: false, });
  },
  createMarkup(data) {
    return { __html: data, }
  },
  handleCarousel(modal, selectedIndex, e) {
    var index = modal + "Index";
    var direction = modal + "Direction";

    this.setState({
      [index]: selectedIndex,
      [direction]: e.direction,
    });
  },
  renderItemAmount(items,type, currency){
    let amount;

    items.map(item =>
      type.indexOf(item.description) >= 0 ?
        amount = item.amount
      : null
    );
    return amount === 0.00 ? "FREE" : currency === "USD" ? "USD " +  numbersWithComma(amount.toFixed(2)) : "₱ " + numbersWithComma(amount.toFixed(2));
  },
  renderSubTotal(items) {
    const subtotal = items.filter((fees) => fees.description === 'Shipping Fee' || fees.description === 'Insurance Fee' || fees.description === 'Storage Fee')
      .reduce((acc, fees) => acc + fees.amount, 0);
    return numbersWithComma(Number(subtotal).toFixed(2));
  },

  handle3plTracking(segment,origin,destination,shipment){
    if (origin === "US" && destination === "PH") {
      return segment.type === "transfer" ? segment.reference_id : segment.type === "acceptance" ? segment.reference_id : null
    }
    if (origin === "US" && destination === "MY") {
      return segment.type === "delivery" ? segment.reference_id : null
    }
    if ((origin === "UK") && destination === "PH") {
      return segment.type === 'delivery' ? segment.reference_id : null;
    }
    if ((origin === "UK" || origin === "AU" || origin === "KR" || origin === "JP") && destination === "MY") {
      return segment.type === "delivery" ? segment.reference_id : null
    }
    if ((origin === "AU" || origin === "JP") && destination === "PH") {
      return segment.type === "delivery" ? segment.reference_id : null
    }
    if (origin === "KR" && destination === "PH") {
      return segment.type === "delivery" ? segment.reference_id : null
    }
  },
  cartModal() {
    return { __html: this.props.cms.getModal ? this.props.cms.modalContent.data.content.body : null, };
  },
  downloadFile(link) {
    fetch(link).then(res => {
      const dlLink = res.url;
      res.blob().then(blob => {
        let url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        // a.style = "display: none";
        a.href = url;
        a.setAttribute(
          'download',
          dlLink.substring(dlLink.lastIndexOf("/")).split('?', 1),
        );
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);

        this.setState({ isDownloading: false });
      })
    })
  },
  render() {
  const outBoundBannerData = this.state.settings && this.state.settings.filter(data => data.name === "outbound_banner");
    return (
      <div>        
        {disabledCart && <Tour />}
        {this.state.isDownloading && 
          <div style={{top: 0, right: 0, left: 0, bottom:0, position:'fixed', alignItems: 'center', background: 'rgba(0,0,0,0.6)',zIndex: '999999', justifyContent: 'center', display: 'flex'}}>
            <div style={{color: '#FFF', }}>
              <i className="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
              <span className="sr-only">Loading...</span>
            </div>
          </div>}
        {/* Start of Floodlight Tag: Please do not remove
        Activity name of this tag: Pay & ship successful  to PH shipping
        URL of the webpage where the tag is expected to be placed: https://www.shippingcart.com/shipment
        This tag must be placed between the <body> and </body> tags, as close as possible to the opening tag.
        Creation Date: 02/04/2020 */}
        <iframe title={uuid()} src="https://9848754.fls.doubleclick.net/activityi;src=9848754;type=paysh0;cat=paysh0;qty=1;cost=1;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;npa=;ord=1?" width="1" height="1" frameBorder="0" style={{ display: 'none' }}></iframe>
        {/* End of Floodlight Tag: Please do not remove */}
        <div className="main-content shipments ">
          {/*MODAL FOR BOX 1*/}

          <Modal className="view-shipping" show={this.state.showModal} onHide={this.close1}>
            <header className="modal-header">
              <Modal.Header closeButton>
              </Modal.Header>
              {this.props.shipmentInfo.fetched_order ?
                <div className="clearfix">
                  <div className="pull-left currentactivity">
                    <h2>Current Activity:</h2>
                    <p>
                      {this.props.shipmentInfo.order.data.events && 
                        this.props.shipmentInfo.order.data.events.map((ev, i, arr) => 
                        i === this.props.shipmentInfo.order.data.events.length - 1 ?
                          ev.status === 'for_acceptance' || ev.status === 'for_transfer' || (this.props.shipmentInfo.order.data.shipment === 'uk-sea' && ev.remarks.toLowerCase().includes("accepted at office")) ? maskEventRemarks(arr[i -1].remarks) 
                          : maskEventRemarks(ev.remarks, ev.status_updated_at, ev.status) : null
                        )
                      } 
                    </p>
                  </div>
                  <div className="pull-right text-center">
                    <label className={this.handleStatuses(this.props.shipmentInfo.fetched_order ? this.props.shipmentInfo.order.data.status : null, "class")}>{this.handleStatuses(this.props.shipmentInfo.fetched_order ? this.props.shipmentInfo.order.data.status : null, "text")}</label>
                    <p>Tracking #: {this.props.shipmentInfo.fetched_order ? this.props.shipmentInfo.order.data.tracking_number : null}</p>
                  </div>
                </div> : null}
            </header>

            {this.props.shipmentInfo.fetched_order ?
              <div className="modal-body padding-3percent">
                <h3>Shipping History: </h3>
                <table>
                  <thead>
                    <tr>
                      <th>Date/Time</th>
                      <th>Activity</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.props.shipmentInfo.order.data.events ?
                      this.props.shipmentInfo.order.data.events.reverse().map((ev, i) => 
                        ev.status === "consolidated" || ev.status === "for_acceptance" || ev.status === 'for_transfer' ||(this.props.shipmentInfo.order.data.shipment === 'uk-sea' && ev.remarks && ev.remarks.toLowerCase().includes("accepted at office")) ?
                        null
                        :
                        <tr key={i}>
                          <td>{format(isMigratedEventRemarks(ev.created_at) ? ev.status_updated_at : ev.created_at, 'MM/DD/YYYY HH:mm:ss')}</td>
                          <td>{maskEventRemarks(ev.remarks, ev.status_updated_at, ev.status)}</td>
                        </tr>
                      )
                      : null
                    }


                  </tbody>
                </table>
              </div> : null}

          </Modal>

          <Modal show={this.state.showModalImage} onHide={this.close}>
            <Modal.Header closeButton>
            </Modal.Header>
            <Modal.Body>
              <Carousel className={this.state.image ? this.state.image.length > 1 ? "" : "disnone" : ""} activeIndex={this.state.zoomIndex} direction={this.state.zoomDirection} onSelect={this.handleCarousel.bind(this, "zoom")}>
                {this.state.image ? this.state.image.map((datas, i) =>
                  <Carousel.Item>
                    <div className="imgcase" key={i}>
                      <img className="imgwd100" src={datas} alt="" />
                    </div>
                  </Carousel.Item>
                ) : null
                }
              </Carousel>
              <img className={this.state.image ? this.state.image.length === 1 ? "imgwd100" : "disnone" : "disnone"} src={this.state.image} alt="" />
            </Modal.Body>
            <Modal.Footer>
            </Modal.Footer>
          </Modal>
          {/* dynamic Banner */}
          {this.state.settings && outBoundBannerData && <div className='shipment-outbound-banner'>
            <OutBoundBanner outBoundBannerData={outBoundBannerData} />
          </div>}
          <div className="top-actions">

            <ul className="shipment-status" role="tablist">
              <li role="presentation" className="active">
                <a href="#All" aria-controls="active" onClick={() => this.handleStatusDisplay("all")} role="tab" data-toggle="tab">All</a>
              </li>
              <li role="presentation" className="">
                <a href="#PendingPayment" onClick={() => this.handleStatusDisplay("pending")} aria-controls="archive" role="tab" data-toggle="tab">Pending Payment</a>
              </li>
              <li role="presentation" className="">
                <a href="#PreparingShipment" onClick={() => this.handleStatusDisplay("preparing")} aria-controls="archive" role="tab" data-toggle="tab">Preparing for Shipment</a>
              </li>
              <li role="presentation" className="">
                <a href="#InTransit" onClick={() => this.handleStatusDisplay("inTransit")} aria-controls="archive" role="tab" data-toggle="tab">On its Way</a>
              </li>
              <li role="presentation" className="">
                <a href="#Delivered" onClick={() => this.handleStatusDisplay("delivered")} aria-controls="archive" role="tab" data-toggle="tab">Delivered</a>
              </li>
            </ul>
            <div className="filter">
              <span>{this.props.shipmentInfo.fetched ? this.props.shipmentInfo.shipment.total : null} Shipments in</span>
              <div className="dropdown">

                <select className="btn btn-white-gradient minimal" value={this.state.value} onChange={this.change}>
                  <option value="3months">Last 3 Months</option>
                  <option value="6months">Last 6 Months</option>
                  <option value={new Date().getFullYear()}>{new Date().getFullYear()}</option>
                  <option value={new Date().getFullYear()-1}>{new Date().getFullYear()-1}</option>
                </select>

              </div>
            </div>
          </div>
          
          <div className="shipment-list tab-content">

            <div role="tabpanel" className="tab-pane active" id="{this.state.tabID}">
              {
                this.props.shipmentInfo.fetched ?
                  this.props.shipmentInfo.shipment.from == null ?
                    <div className="shipment-list clearfix">
                      <div className="no-result">No Results Found</div>
                    </div>
                  : this.props.shipmentInfo.fetching ? null
                    : this.props.shipmentInfo.shipment.data.filter(ship => ship.payment_reference_id !== "").map((ship, i) =>

                      <div key={i} className="shipment-list-wrapper" ref={ship.reference_id}>
                        <div className="shipment-head clearfix" style={{backgroundColor: '#F1F1F1'}}>
                          <div className="shipment-type">
                            {ship.shipment.includes("air") ? <h5 className="air">Air Cargo</h5> : <h5 className="sea">Sea Cargo</h5>}
                          </div>
                          <div className="shipment-transaction">
                            <h6>Transaction Date:</h6>
                            <p>{format(new Date((ship.tat.pending) * 1000), 'MM/DD/YYYY')}</p>
                            <h6>Transaction #:</h6>
                            <p>{ship.payment_reference_id}</p>
                          </div>
                          <div className="shipment-to">                            
                            <h6>From:</h6>
                            <p>{maskLocationName(ship.pickup_address.country.code)+" Warehouse"}</p>
                            <h6>Ship to:</h6>
                            <p>{ship.delivery_address.name}
                              <br /> {ship.delivery_address.line_1},&nbsp;{ship.delivery_address.district}
                              &nbsp; {ship.delivery_address.city},&nbsp;{ship.delivery_address.state}
                              &nbsp; {ship.delivery_address.country.name},&nbsp;{ship.delivery_address.postal_code}
                            </p>
                            <p>{ship.delivery_address.phone_number}</p>
                          </div>
                          <div className="shipment-delivery">
                            <h6>Estimated Delivery Date:</h6>
                            <p>{format(ship.shipment.includes("air") ? ship.metadata.delivery_tat ? ship.metadata.delivery_tat.air : null : ship.metadata.delivery_tat ? ship.metadata.delivery_tat.sea : null, 'MM/DD/YYYY')}</p>
                          </div>
                        </div>
                        {ship.damage_items && !!ship.damage_items.total && 
                          <DamagedBanner
                            message={
                              <div>
                                <span style={{ fontWeight: 600 }}>
                                  {ship.damage_items && ship.damage_items.total} out of{' '}
                                  {ship.parcels && ship.parcels.total} packages
                                </span>{' '}
                                contains{' '}
                                <span
                                  style={{ color: '#0375D9', fontWeight: 600, cursor: 'pointer' }}
                                  onClick={() => this.setState({ damagedModalOpen: true, damagedItemsList: ship.damage_items })}
                                >
                                  damaged item
                                </span>{' '}
                                which are excluded from SC Protect when you checkout.
                              </div>
                            }
                            bgColor="#FFE9EB"
                            marginTop="0px"
                            padding="10px 20px"
                          />
                        }

                        {/*START OF BOX 1*/}
                        <div className="shipment-box clearfix">
                          <div className="shipment-box-wrapper">
                            <div data-do="image-modal" className="shipment-image" style={{maxWidth: '160px'}}>
                              <div style={{backgroundColor: '#2C985B', color: '#F9F9F9', padding: '5px', width: 'fit-content', marginBottom: '10px', borderRadius: '4px', textTransform: 'uppercase', fontWeight: 600, fontSize: '12px'}}>Box 1</div>
                              {ship.items ? ship.items.filter(item => item.type === "product").map((item, i) =>
                                  <div key={i} className={i === 0 ? "" : "disnone"}>
                                  <a onClick={this.handleImage.bind(this, ship.items)} data-toggle="lightbox" data-gallery="hiddenimages">
                                    <img src={item.metadata.parcel.images[0]} className="img-responsive" alt="" />
                                  </a>
                                </div>) : null}
                            </div>

                            <div className="shipment-item" style={{maxWidth: '175px'}}>
                              <h6>Item/s</h6>
                              {
                              ship.printable && <button style={{
                                  border: 'none',
                                  background: 'none',
                                  color: '#0375D9',
                                  padding: 0
                                }} onClick={() => {
                                  axios.post(apiUrl+'users/print/bol', {"data":{
                                    "tracking_number":[ship.tracking_number],
                                    "shipment": ship.shipment,
                                    "country_destination": ship.delivery_address.country.code
                                  }}).then((res) => {
                                    const link = res.data.bol;
                                    this.downloadFile(link);
                                  }).catch((err) => {
                                    console.log(err, 'error')
                                  })
                                }}>
                                  Download Bill of Lading
                                </button>
                              }
                              <ul>
                                {ship.items.filter(item => item.type === "product").map((item, i) =>
                                  <li key={i}>
                                    {item.description}
                                    {item.metadata.parcel.flags.is_abandoned ? <span className="icon-hope"/> : null}
                                  </li>
                                )}
                              </ul>
                            </div>

                            <div className="shipment-status" style={{maxWidth: '325px'}}>
                              <div className="shipment-update" style={{padding: '10px 0px'}} data-lazy="true" data-lazy-id="68577" data-lazy-tracking="1095781790" data-lazy-status="PAID" data-lazy-delivered-date="">
                                {
                                  this.handleStatuses(ship.status, "text") === "PREPARING FOR SHIPMENT" ?
                                    <div className="tracking-update">
                                      <div className="track-and-trace">
                                        <div className="top-label"><strong>Latest Update:</strong></div>
                                        <div className="update-details">Your package is being processed for shipping.</div>
                                      </div>
                                    </div>
                                  : null
                                }
                                {ship.reason && ship.payment_status === 'rejected' &&
                                  <div className="track-and-trace" >
                                    <div className="top-label"><strong>Reason:</strong></div>
                                    <div className="update-details">{ship.reason}</div>
                                  </div>
                                }
                                {
                                  this.handleStatuses(ship.status, "text") === "DELIVERED" || this.handleStatuses(ship.status, "text") === "ON ITS WAY" ?
                                    <div className="tracking-update">
                                      {ship.events ? ship.events.map((ev, i, arr) => i === ship.events.length - 1 ?
                                          <div className="track-and-trace" key={i}>
                                            <div className="top-label"><strong>Latest Update:</strong></div>
                                            <div className="update-date">{format(isMigratedEventRemarks(ev.created_at) ? ev.status_updated_at : ev.created_at, 'MM/DD/YYYY HH:mm:ss')}</div>
                                            <div className="update-details">{ev.status === 'for_acceptance' || (ship && ship.shipment === 'uk-sea' && ev.remarks && ev.remarks.toLowerCase().includes("accepted at office")) ? maskEventRemarks(arr[i - 1].remarks) : maskEventRemarks(ev.remarks, ev.status_updated_at, ship.status)}</div>
                                          </div>
                                        : null ) : null
                                      }
                                      <a className="modalanchor" onClick={this.open.bind(this, ship.tracking_number)}><p>{this.handleStatuses(ship.status, "text") === "DELIVERED" ? "Tracking History" : "Tracking Details"}</p></a>
                                      <p>Tracking #: {ship.tracking_number}</p>
                                      <p>Alternate Tracking:&nbsp;
                                      {ship.segments && ship.segments.map((segment,id) => 
                                        <a key={id} target="blank"
                                          href={`https://parcelsapp.com/en/tracking/${this.handle3plTracking(segment,ship.pickup_address.country.code,ship.delivery_address.country.code,ship.shipment)}`}>
                                          { this.handle3plTracking(segment,ship.pickup_address.country.code,ship.delivery_address.country.code,ship.shipment)}
                                        </a>
                                      )}
                                      </p>
                                      {ship.status === 'delivered' && <a href="/referral?utm_source=web&utm_medium=delivered-shipment&utm_campaign=ph-web-delivered-shipment-referral-20220727">
                                        <button className="btn btn-orange referral-button">REFERRAL PROMO | LEARN MORE</button>
                                      </a>}
                                    </div> : null
                                }
                              </div>
                            </div>
                            <div className="shipment-status" style={{maxWidth: '198px'}}>
                              <h6 style={{marginBottom: '5px'}}>Status:</h6>
                              <div className='shipment-status-wrapper'>
                                {this.handleStatuses(ship.status, "text", ship.payment_status)}
                              </div>
                                {ship.sc_protect && ship.sc_protect.coc && 
                                  <div style={{display: 'flex', flexDirection: 'column', margin: '15px 0px'}}>
                                    <img src="https://cdn.shippingcart.com/assets/sc-protect-logo-final-20231123025932.svg" alt='badge' width={18} height={18}/>
                                    <div style={{fontSize: '10px', marginTop: '5px'}}>SC Protect, powered by Stere & underwritten by PLGIC, is a partnership between SC and SPI.</div>
                                    <div style={{fontSize: '13px', fontWeight: 600, color: '#0375D9', marginTop: '15px', cursor: 'pointer'}}
                                      onClick={() => {
                                        this.setState({ isDownloading: true });
                                        axios.get(`${apiUrl}policy/${ship.sc_protect.coc}`).then((res) => {
                                          const link = res.data.data.policy;
                                          this.downloadFile(link);
                                        }).catch((err) => {
                                          console.log(err, 'error')
                                          this.setState({ isDownloading: false });
                                        })
                                      }}>
                                      Download Insurance Policy
                                    </div>
                                  </div>
                                }
                            </div>

                          </div>
                        </div>
                        {/*END OF BOX 1*/}

                        {/*START OF SPLITBOX*/}
                        {ship.children ? ship.children.length > 0 ? ship.children.map((child, i) =>
                          <div className="shipment-box clearfix" key={i}>
                            <div className="shipment-box-wrapper">
                              <div data-do="image-modal" className="shipment-image" style={{maxWidth: '160px'}}>
                                <div style={{backgroundColor: '#2C985B', color: '#F9F9F9', padding: '5px', width: 'fit-content', marginBottom: '10px', borderRadius: '4px', textTransform: 'uppercase', fontWeight: 600, fontSize: '12px'}}>Box {i + 2}</div>
                                {
                                  child.items ? child.items.filter(item => item.type === "product").map((item, i) =>
                                    <div key={i} className={i === 0 ? "" : "disnone"}>
                                    <a onClick={this.handleImage.bind(this, child.items)} data-toggle="lightbox" data-gallery="hiddenimages">
                                      <img src={item.metadata.parcel.images[0]} className="img-responsive" alt="" />
                                    </a>
                                  </div>) : null
                                }
                              </div>
                              <div className="shipment-item" style={{maxWidth: '175px'}}>
                                <h6>Item/s</h6>
                                {
                              ship.printable && <button style={{
                                  border: 'none',
                                  background: 'none',
                                  color: '#0375D9',
                                  padding: 0
                                }} onClick={() => {
                                  axios.post(apiUrl+'users/print/bol', {"data":{
                                    "tracking_number":[child.tracking_number],
                                    "shipment": child.shipment,
                                    "country_destination": ship.delivery_address.country.code
                                  }}).then((res) => {
                                    const link = res.data.bol;
                                    this.downloadFile(link);
                                  }).catch((err) => {
                                    console.log(err, 'error')
                                  })
                                }}>
                                  Download Bill of Lading
                                </button>
                              }
                                <ul>
                                  {child.items && child.items.filter(item => item.type === "product").map((item, i) =>
                                    <li key={i}>
                                      {item.description}
                                      {item.metadata.parcel.flags.is_abandoned ? <span className="icon-hope"/> : null}
                                    </li>
                                  )}
                                </ul>
                              </div>
                              <div className="shipment-status" style={{maxWidth: '325px'}}>
                                <div className="shipment-update" style={{padding: '10px 0px'}} data-lazy="true" data-lazy-id="68577" data-lazy-tracking="1095781790" data-lazy-status="PAID" data-lazy-delivered-date="">
                                  {
                                    this.handleStatuses(child.status, "text") === "PREPARING FOR SHIPMENT" ?
                                      <div className="tracking-update">
                                        <div className="track-and-trace">
                                          <div className="top-label"><strong>Latest Update:</strong></div>
                                          <div className="update-details">Your package is being processed for shipping.</div>
                                        </div>
                                      </div>
                                    : null
                                  }
                                  {
                                    this.handleStatuses(child.status, "text") === "DELIVERED" || this.handleStatuses(child.status, "text") === "ON ITS WAY" ?
                                      <div className="tracking-update">
                                        {child.events ? child.events.map((ev, i, arr) => i === 0 ?
                                            <div className="track-and-trace" key={i}>
                                              <div className="top-label"><strong>Latest Update:</strong></div>
                                              <div className="update-date">{format(isMigratedEventRemarks(ev.created_at) ? ev.status_updated_at : ev.created_at, 'MM/DD/YYYY HH:mm:ss')}</div>
                                              <div className="update-details">{ev.status === 'for_acceptance' || (child && child.shipment === 'uk-sea' && ev.remarks && ev.remarks.toLowerCase().includes("accepted at office")) ? maskEventRemarks(arr[i - 1].remarks)  : maskEventRemarks(arr[arr.length - 1].remarks, ev.status_updated_at, child.status)}</div>
                                            </div>
                                          : null) : null}
                                        <a className="modalanchor" onClick={this.open.bind(this, child.tracking_number)}><p>{this.handleStatuses(child.status, "text") === "DELIVERED" ? "Tracking History" : "Tracking Details"}</p></a>
                                        <p>Tracking #: {child.tracking_number}</p>
                                        <p>Alternate Tracking:&nbsp;
                                          {child.segments && child.segments.map((segment,id) => 
                                            <a key={id} target="blank"
                                              href={`https://parcelsapp.com/en/tracking/${this.handle3plTracking(segment,ship.pickup_address.country.code,ship.delivery_address.country.code,ship.shipment)}`}>
                                              { this.handle3plTracking(segment,ship.pickup_address.country.code,ship.delivery_address.country.code,ship.shipment)}
                                            </a>
                                          )}
                                        </p>
                                        {child.status === 'delivered' && <a href="/referral?utm_source=web&utm_medium=delivered-shipment&utm_campaign=ph-web-delivered-shipment-referral-20220727">
                                          <button className="btn btn-orange referral-button">REFERRAL PROMO | LEARN MORE</button>
                                        </a>}
                                      </div>
                                    : null
                                  }
                                </div>
                              </div>
                              <div className="shipment-status" style={{maxWidth: '198px'}}>
                                <h6 style={{marginBottom: '5px'}}>Status:</h6>
                                <div className='shipment-status-wrapper'>
                                  {this.handleStatuses(child.status, "text", child.payment_status)}
                                </div>
                                {ship.sc_protect && ship.sc_protect.coc && 
                                  <div style={{display: 'flex', flexDirection: 'column', margin: '15px 0px'}}>
                                    <img src="https://cdn.shippingcart.com/assets/sc-protect-logo-final-20231123025932.svg" alt='badge' width={18} height={18}/>
                                    <div style={{fontSize: '10px', marginTop: '5px'}}>SC Protect, powered by Stere & underwritten by PLGIC, is a partnership between SC and SPI.</div>
                                    <div style={{fontSize: '13px', fontWeight: 600, color: '#0375D9', marginTop: '15px', cursor: 'pointer'}}
                                      onClick={() => {
                                        this.setState({ isDownloading: true });
                                        axios.get(`${apiUrl}policy/${ship.sc_protect.coc}`).then((res) => {
                                          const link = res.data.data.policy;
                                          this.downloadFile(link);
                                        }).catch((err) => {
                                          console.log(err, 'error')
                                          this.setState({ isDownloading: false });
                                        })
                                      }}>
                                      Download Insurance Policy
                                    </div>
                                  </div>
                                }
                              </div>
                            </div>
                          </div>
                        ) : null : null}
                        {/*END OF SPLITBOX*/}

                        <div className="transaction clearfix">
                          <div className="transaction-wrapper">
                            <div className="collapse-head collapsed" data-toggle="collapse" data-target={"#" + ship.id} ref={ship.id}>Transaction Details:</div>
                            <div id={ship.id} className="collapse collapse-content">
                              <div className="breakdown">
                                <div className="breakdown-item clearfix">
                                  <p className="left">{ship.shipment.includes("air") ? "Air" : "Sea"} Cargo Fee:</p>
                                  <p className="right">{this.renderItemAmount(ship.items,['Shipping Fee', 'Cargo Fee'], ship.currency)}</p>
                                </div>
                                <div className="breakdown-item clearfix">
                                  <p className="left">
                                    <div style={{display: 'inline-flex'}}>
                                      SC Protect Fee 
                                      {ship.sc_protect && ship.sc_protect.opt_in && <div className='fa icon-sc-protect fa-fw' style={{width: '16px', height: '16px', backgroundSize: 'cover', alignSelf: 'center', marginLeft: '5px', marginRight: '3px',}}>
                                        {ship.sc_protect.type === 'stere' && <div className="tooltip special-handling-tooltip white">
                                          <p>SC Protect, powered by Stere & underwritten by PLGIC, is a partnership between SC and SPI.</p>
                                        </div>}
                                      </div>}:
                                    </div>
                                  </p>
                                  <p className="right">{this.renderItemAmount(ship.items,'Insurance Fee', ship.currency)}</p>
                                </div>
                                <div className="breakdown-item clearfix">
                                  <p className="left">Storage Fee:</p>
                                  <p className="right">{this.renderItemAmount(ship.items,'Storage Fee', ship.currency)}</p>
                                </div>
                                <div className="breakdown-item clearfix">
                                  <p className="left">{ship.shipment.includes("air") ? "Air" : "Sea"} Cargo Subtotal:</p>
                                  <p className="right"><b>
                                  { ship.total === "0.00" ? "FREE" : ship.currency === "USD" ? "USD " : "₱ " }
                                  {this.renderSubTotal(ship.items)}
                                  </b></p>
                                </div>

                                {
                                  ship.items.map((item, i) => item.type === "discount" ?
                                    item.metadata ? 
                                    <div key={i}>
                                      <div className="breakdown-item clearfix">
                                        <p className="left">Discount ({item.metadata.code}|{item.metadata.value}{item.metadata.type === "percentage" ? "%" : null} OFF):</p>
                                        <p className="right">- {ship.currency === "USD" ? "USD " : "₱ "} {parseFloat(ship.discount) * -1}</p>
                                      </div>
                                    </div>
                                    :
                                    null
                                  : null )
                                }

                                {
                                  Object.prototype.hasOwnProperty.call(ship.metadata, 'sc_promotional_orders') && parseInt(ship.metadata.sc_promotional_orders, 10) ?
                                    ship.shipment.includes('sea') && Object.prototype.hasOwnProperty.call(ship.metadata, 'sc_promotional_fee_per_shipment') && ship.metadata.sc_promotional_fee_per_shipment.sea !== "0" ?
                                      <div className="breakdown-item clearfix">
                                        <p className="left">Project Hope Donation:</p>
                                        <p className="right">USD {numbersWithComma(Number(ship.metadata.sc_promotional_fee_per_shipment.sea).toFixed(2))}</p>
                                      </div>
                                    : ship.shipment.includes('air') && Object.prototype.hasOwnProperty.call(ship.metadata, 'sc_promotional_fee_per_shipment') && ship.metadata.sc_promotional_fee_per_shipment.air !== "0" ?
                                      <div className="breakdown-item clearfix">
                                        <p className="left">Project Hope Donation:</p>
                                        <p className="right">USD {Object.prototype.hasOwnProperty.call(ship.metadata, 'sc_promotional_fee_per_shipment') ? numbersWithComma(Number(ship.metadata.sc_promotional_fee_per_shipment.air).toFixed(2)) : "5.00"}</p>
                                      </div>
                                    : null
                                  : null
                                }
                                
                              </div>

                              <div className="total">
                                <div className="total-item clearfix">
                                  <div>
                                  <p className="left">Total ShippingCart Fee:</p>
                                  <p className="right">{ship.currency === "USD" ? "USD " : "₱ "}  {numbersWithComma(Number(ship.total).toFixed(2))}</p>
                                </div>
                                <div className='left'>
                                { 
                                  ship.printable && <button style={{
                                    border: 'none',
                                    background: 'none',
                                    width: 166,
                                    color: '#0375D9'
                                  }} onClick={() => {
                                    axios.post(apiUrl+'users/print/invoice', {"data":{
                                      "tracking_number":[ship.tracking_number],
                                      "reference_id": ship.reference_id
                                    }}).then((res) => {
                                      const link = res.data.pod;
                                      this.downloadFile(link);
                                    }).catch((err) => {
                                      console.log(err, 'error')
                                    })
                                  }}>
                                    Download Invoice
                                  </button>
                                }
                                </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                  )
                : null
              }
              {
                this.props.shipmentInfo.fetched ? this.props.shipmentInfo.shipment.from == null ? null :
                  <Pagination first prev next ellipsis
                    last={this.state.activePage + 2 >= this.props.shipmentInfo.shipment.last_page ? false : this.props.shipmentInfo.shipment.last_page}
                    boundaryLinks={false}
                    items={this.props.shipmentInfo.fetched ? this.props.shipmentInfo.shipment.last_page : null}
                    maxButtons={5}
                    activePage={this.state.activePage}
                    onSelect={this.handleSelect}
                  />
                : null
              }

            </div>
          </div>

          <div className="bottom-actions clearfix">

          </div>


        </div>
        {localStorage.cartModalShowed ? null :
          this.props.cms.modalContent ?
            disabledCart && this.props.cms.getModal && this.props.cms.modalContent.data.status ?
              <AdvisoryModal show={this.props.cms.showAdvisoryModal['cart']}
                close={dispatch => this.props.closeModal('cart')}
                content={this.cartModal()}
              />
            : null
          : null
        }

        <DamagedModal
          isOpen={this.state.damagedModalOpen}
          handleClose={() => this.setState({damagedModalOpen : false, damagedItemsList: null})}
          damageItems={this.state.damagedItemsList}
        />
      </div>
    )
  },


});

export default Shipment;



/** WEBPACK FOOTER **
 ** ./src/components/DashboardFiles/Shipment.js
 **/